// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1WvpE","cell":"ColumnAccessor_cell__27ip0","firstCellAccent":"ColumnAccessor_firstCellAccent__NW_up"};